<template>
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-if="participant">
        <div class="box-layout-inner childCourseBlock">
            <div class="title-block-alt">
                <div class="alt-container">
                    <span> {{ participant.full_name }} </span>
                </div>
            </div>

            <div class="content-block">
                <booking-item @update="update" v-bind:bookingId="booking_id" v-bind:participant="participant" v-for="item in participant.items" v-bind:item="item" v-bind:key="item.id"></booking-item>
            </div>

            <div class="full-width-cta" v-if="editable">
                <router-link class="cta-button red" :to="{ name: 'booking.quickadd', params: { venueId: participant.items[0].venue_id, childId: participant.items[0].participant_id } }">{{ $parent.$parent.locale.button_quick_add_more }}</router-link>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props: [ 'participant', 'booking_id', 'editable'],
        components: {
            'booking-item': require('./BasketBookingItem.vue')
        },
        methods: {
            update: function () {
                this.$emit('update');
            }
        },
    }
</script>



// WEBPACK FOOTER //
// BasketItem.vue?376ffabd